/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type StreamTerminalEvents200Response,
    StreamTerminalEvents200ResponseFromJSON,
    StreamTerminalEvents200ResponseToJSON,
} from '../models/StreamTerminalEvents200Response';

export interface StreamTerminalEventsRequest {
    locationId: number;
    ids: Array<string>;
}

/**
 * 
 */
export class TerminalSseControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for streamTerminalEvents without sending the request
     */
    async streamTerminalEventsRequestOpts(requestParameters: StreamTerminalEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling streamTerminalEvents().'
            );
        }

        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling streamTerminalEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/terminals/events`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async streamTerminalEventsRaw(requestParameters: StreamTerminalEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamTerminalEvents200Response>> {
        const requestOptions = await this.streamTerminalEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamTerminalEvents200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async streamTerminalEvents(requestParameters: StreamTerminalEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamTerminalEvents200Response> {
        const response = await this.streamTerminalEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
